// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-E_Z","name":"styles_name__2HmqN","phone":"styles_phone__3POaD"};